__turbopack_context__.v({
  "container": "styles-module__X9vkdq__container",
  "thumb": "styles-module__X9vkdq__thumb",
});
